import * as React from 'react';
import { observer } from 'mobx-react';

import { DocumentTemplateMarketView } from './market.view';
import { DocumentTemplateMarketDataService } from './market-form.data';

interface Props extends ComponentViewProps<IDocumentTemplateItem> {
	dataService: DocumentTemplateMarketDataService;
	mode: ControlMode;
}

@observer
export class DocumentTemplateMarketController extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}

	handleCreateDocumentTemplateMarket = async(): Promise<DocumentTemplateMarketItem> => {
		const { dataService, model } = this.props;
		let market = await dataService.add(model);
		return market;
	};

	render() {
		const { dataService, mode, setBusy } = this.props;
		if (dataService == null || dataService.items == null) {
			return null;
		}

		return (
			<DocumentTemplateMarketView
				model={dataService}
				onCreateDocumentTemplateMarket={this.handleCreateDocumentTemplateMarket}
				mode={mode}
				setBusy={setBusy}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/document-templates/form/markets/market.controller.tsx